import React, { Fragment } from 'react';
import { IconMenu } from '../../../components';
import { DeleteOutline, Edit } from '@mui/icons-material';
import { useTranslations } from 'next-intl';
import { useTheme, useToggle } from '../../../hooks';
import { Post } from '../../../types/Post';
import { deletePost } from '../../../api/posts';
import { PostEditModal } from './modal/ProjectDetailsCoWorkCreatePostModal';

type Props = {
    post: Post;
    refresh: () => void;
    isUserAuthor: boolean;
};

export const ProjectDetailsCoWorkPostSectionEditPost = ({ post, refresh, isUserAuthor }: Props) => {
    const t = useTranslations('details');
    const { colors } = useTheme();
    const [isEditModalOpen, toggleEditModal] = useToggle();

    const onDelete = () => deletePost(post.id).then(refresh);

    return (
        <Fragment>
            <IconMenu
                style={{ position: 'absolute', right: 0, top: 0 }}
                items={[
                    {
                        icon: <DeleteOutline />,
                        text: t('delete_post'),
                        onClick: onDelete,
                        color: colors.error
                    },
                    ...(isUserAuthor
                        ? [
                              {
                                  icon: <Edit />,
                                  text: t('edit_post'),
                                  onClick: toggleEditModal
                              }
                          ]
                        : [])
                ]}
            />
            {isEditModalOpen && (
                <PostEditModal
                    post={post}
                    onClose={() => toggleEditModal(false)}
                    onSuccess={refresh}
                />
            )}
        </Fragment>
    );
};
